import {
  ChoiceGroup as FChoiceGroup,
  IChoiceGroupProps as FIChoiceGroupProps,
  IChoiceGroupStyles,
} from '@fluentui/react';
import { forwardRef, Ref } from 'react';

import { IComponent } from '../../models/components.models';
import { useThemeStyles } from '../../utils/hooks';
import { choiceGroupStylesDefault } from './ChoiceGroup.styles';

export interface IChoiceGroupProps extends Omit<FIChoiceGroupProps, 'styles'>, IComponent<IChoiceGroupStyles> {}

export const ChoiceGroup = forwardRef((props: IChoiceGroupProps, ref: Ref<HTMLDivElement>) => {
  const { styles, ..._fProps } = props;
  const fProps: FIChoiceGroupProps = {
    ..._fProps,
    styles: useThemeStyles<Partial<IChoiceGroupStyles>>(choiceGroupStylesDefault, styles),
  };
  return <FChoiceGroup {...fProps} ref={ref} data-test={props['data-test'] || 'choice-group'} />;
});
